/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminBankDetails
 */
export interface AdminBankDetails {
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    readonly url?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    readonly user?: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminBankDetails
     */
    readonly dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdminBankDetails
     */
    readonly dateUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankAccountName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankAccountNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankSortCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankPostcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankIban: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankRoutingCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankAccountHoldingBranch?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankBicSwiftCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    bankPaymentMethod?: AdminBankDetailsBankPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    intermediaryBankName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    intermediaryBankAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    intermediaryBankBicSwiftCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminBankDetails
     */
    intermediaryBankCountry?: string | null;
}


/**
 * @export
 */
export const AdminBankDetailsBankPaymentMethodEnum = {
    BankTransfer: 'bank_transfer',
    Cheque: 'cheque'
} as const;
export type AdminBankDetailsBankPaymentMethodEnum = typeof AdminBankDetailsBankPaymentMethodEnum[keyof typeof AdminBankDetailsBankPaymentMethodEnum];


/**
 * Check if a given object implements the AdminBankDetails interface.
 */
export function instanceOfAdminBankDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bankAccountNumber" in value;
    isInstance = isInstance && "bankSortCode" in value;
    isInstance = isInstance && "bankName" in value;
    isInstance = isInstance && "bankAddress" in value;
    isInstance = isInstance && "bankIban" in value;

    return isInstance;
}

export function AdminBankDetailsFromJSON(json: any): AdminBankDetails {
    return AdminBankDetailsFromJSONTyped(json, false);
}

export function AdminBankDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminBankDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'dateCreated': !exists(json, 'date_created') ? undefined : (new Date(json['date_created'])),
        'dateUpdated': !exists(json, 'date_updated') ? undefined : (new Date(json['date_updated'])),
        'bankAccountName': !exists(json, 'bank_account_name') ? undefined : json['bank_account_name'],
        'bankAccountNumber': json['bank_account_number'],
        'bankSortCode': json['bank_sort_code'],
        'bankName': json['bank_name'],
        'bankAddress': json['bank_address'],
        'bankPostcode': !exists(json, 'bank_postcode') ? undefined : json['bank_postcode'],
        'bankIban': json['bank_iban'],
        'bankRoutingCode': !exists(json, 'bank_routing_code') ? undefined : json['bank_routing_code'],
        'bankAccountHoldingBranch': !exists(json, 'bank_account_holding_branch') ? undefined : json['bank_account_holding_branch'],
        'bankBicSwiftCode': !exists(json, 'bank_bic_swift_code') ? undefined : json['bank_bic_swift_code'],
        'bankPaymentMethod': !exists(json, 'bank_payment_method') ? undefined : json['bank_payment_method'],
        'intermediaryBankName': !exists(json, 'intermediary_bank_name') ? undefined : json['intermediary_bank_name'],
        'intermediaryBankAddress': !exists(json, 'intermediary_bank_address') ? undefined : json['intermediary_bank_address'],
        'intermediaryBankBicSwiftCode': !exists(json, 'intermediary_bank_bic_swift_code') ? undefined : json['intermediary_bank_bic_swift_code'],
        'intermediaryBankCountry': !exists(json, 'intermediary_bank_country') ? undefined : json['intermediary_bank_country'],
    };
}

export function AdminBankDetailsToJSON(value?: AdminBankDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bank_account_name': value.bankAccountName,
        'bank_account_number': value.bankAccountNumber,
        'bank_sort_code': value.bankSortCode,
        'bank_name': value.bankName,
        'bank_address': value.bankAddress,
        'bank_postcode': value.bankPostcode,
        'bank_iban': value.bankIban,
        'bank_routing_code': value.bankRoutingCode,
        'bank_account_holding_branch': value.bankAccountHoldingBranch,
        'bank_bic_swift_code': value.bankBicSwiftCode,
        'bank_payment_method': value.bankPaymentMethod,
        'intermediary_bank_name': value.intermediaryBankName,
        'intermediary_bank_address': value.intermediaryBankAddress,
        'intermediary_bank_bic_swift_code': value.intermediaryBankBicSwiftCode,
        'intermediary_bank_country': value.intermediaryBankCountry,
    };
}

